package `fun`.adaptive.cookbook

import `fun`.adaptive.resource.document.Documents
import `fun`.adaptive.resource.document.DocumentResource
import `fun`.adaptive.resource.document.DocumentResourceSet

private object commonMainDocument0 {

    val double_input by lazy { init_double_input() }

    val markdown_demo by lazy { init_markdown_demo() }

    val date_input by lazy { init_date_input() }

}

val Documents.double_input
    get() = commonMainDocument0.double_input

private fun init_double_input() =
    DocumentResourceSet(
        name = "double_input",
        DocumentResource("/fun.adaptive.cookbook/documents/double_input.md", setOf())
    )

val Documents.markdown_demo
    get() = commonMainDocument0.markdown_demo

private fun init_markdown_demo() =
    DocumentResourceSet(
        name = "markdown_demo",
        DocumentResource("/fun.adaptive.cookbook/documents/markdown_demo.md", setOf())
    )

val Documents.date_input
    get() = commonMainDocument0.date_input

private fun init_date_input() =
    DocumentResourceSet(
        name = "date_input",
        DocumentResource("/fun.adaptive.cookbook/documents/date_input.md", setOf())
    )